import React from 'react';
import { YouTube } from '@mui/icons-material';

import QualificationsField from '../common/fields/QualificationsField';
import InputField from '../common/fields/InputField';

function ProfessionalDetailsStep({
  formData,
  setFormData,
  qualifications,
  setQualifications,
  errors,
}) {
  return (
    <div className="space-y-4">
      <InputField
        label="Bio"
        multiline
        rows={4}
        required
        value={formData.bio}
        onChange={(e) => setFormData({ ...formData, bio: e.target.value })}
        error={!!errors?.bio}
        helperText={errors?.bio?.[0]}
        placeholder="Tell us about your teaching experience..."
      />

      <InputField
        label="YouTube Intro Video URL"
        value={formData.introVideoUrl}
        onChange={(e) => setFormData({ ...formData, introVideoUrl: e.target.value })}
        error={!!errors?.introVideoUrl}
        helperText={errors?.introVideoUrl?.[0]}
        placeholder="https://www.youtube.com/watch?v=..."
        slotProps={{
          input: {
            startAdornment: <YouTube sx={{ color: '#F6911D', mr: 1 }} />,
          },
        }}
      />

      <div className="space-y-3">
        <QualificationsField
          value={qualifications}
          onChange={setQualifications}
          error={!!errors?.qualifications}
          helperText={errors?.qualifications?.[0]}
          label="Educational Qualifications"
          required
          minItems={1}
        />
      </div>
    </div>
  );
}

export default ProfessionalDetailsStep;
